<template>
    <div class="products">
        <div class="main">
            <div class="titbox">
                <h3>产品介绍</h3>
                <!-- <p>实现异构、异主、异地数据便捷、安全、可控、开放的互联互通与安全共享，帮助机构、企业降低成本、提升效率，提升安全性</p> -->
            </div>
            <div class="cardList">
                <ul class="cardList_item">
                    <li :to="item.path" v-for="item of productsList" :key="item.id">
                        <div class="cardBox">
                            <a :href="item.path">
                                <i class="i-toggle-nav i-toggle-1">
                                    <img :src=item.img :alt="item.title">
                                </i>
                                <i class="i-toggle-nav i-toggle-1 i-toggle-yellow" :class="{ 'active': isActive }">
                                    <img :src=item.img :alt="item.title">
                                </i>
                                <h3>{{item.title}}</h3>
                                <p>{{item.text}}</p>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Products',
  data () {
    return {
      productsList: [
        {
          id: '1',
          title: '前缀产品',
          text: '前缀是机构重要的虚拟资产，是机构、企业、个人等用户接入Handle全球体系架构和我国工业互联网标识解析体系的数字身份。注册前缀主要有标识注册和标识预留两种形式。',
          img: require('../../assets/img/icon/product-1.png'),
          isActive: 'i-toggle-yellow1',
          path: '/prefix'
        },
        {
          id: '2',
          title: '信息路由',
          text: '信息路由器为每一条数据、每一个应用系统提供一个全球永久、唯一的身份信息，并使用更为安全的协议为数据传输提供可靠方式，借助信息路由器接入全球“数据总线”，帮助用户实现异构、异主、异地数据的互联互通与安全共享，帮助机构、企业降低成本、提升效率，提升安全性。',
          img: require('../../assets/img/icon/product-2.png'),
          isActive: 'i-toggle-yellow2',
          path: '/infor-router'
        },
        {
          id: '3',
          title: '数据管理系统',
          text: '数据管理系统既可以帮助行业协会、龙头企业、大规模集团等建立行业性、区域性的数据治理体系，也可以帮助普通机构、企业建立符合行业、区域、国家乃至国际的数据全球化发展背景下的数字化转型目标。',
          img: require('../../assets/img/icon/product-3.png'),
          isActive: 'i-toggle-yellow3',
          path: '/data-manage'
        }
      ]
    }
  }
}
</script>

<style lang="less">
.products{
    width: 100%;
    background-color: #f7f9fc;
    .main {
        width:1200px;
        margin:auto;
        padding-bottom: 120px;
        .titbox{
            width: 100%;
            text-align: center;
            color:#333;
            padding:70px 0;
            h3{
                font-size: 36px;
                line-height: 1.3;
            }
            p{
                font-size: 16px;
                color:#666;
                margin-top:15px
            }
        }
        .cardList{
            width: 100%;
            .cardList_item{
                display: flex;
                li {
                    flex:1;
                    .cardBox {
                        position: relative;
                        padding: 0 20px;
                        text-align: justify;
                        color:#616161;
                        a {
                            display: block;
                            width:100%;
                            height:100%;
                            color: #333;
                            .i-toggle-nav,
                            .i-toggle-1{
                                width:160px;
                                height:160px;
                                overflow: hidden;
                            }
                            .i-toggle-nav{
                                display: block;
                                margin:0 auto 20px;
                            }
                            .i-toggle-1 img,.i-toggle-yellow img {
                                width:100%
                            }
                            .i-toggle-yellow{
                                position: absolute;
                                top:0;
                                left: 50%;
                                margin-left: -80px;
                                opacity: 0;
                                transition: all .3s ease-out;
                            }
                            .i-toggle-yellow1,.i-toggle-yellow2{
                                top:1;
                            }
                            .i-toggle-yellow3{
                                top:0;
                            }
                            .i-toggle-yellow4{
                                top:2;
                            }
                            .i-toggle-yellow img{
                                margin-top: -182px;
                            }
                            h3{
                                position: relative;
                                margin-bottom: 10px;
                                padding-bottom: 10px;
                                font-weight: bold;
                                font-size: 16px;
                                text-align: center;
                                color: #333;
                            }
                            h3:after{
                                position: absolute;
                                width: 20px;
                                height: 1px;
                                content: '';
                                background: #333;
                                top:40px;
                                left: 50%;
                                margin-left: -10px;
                                transition: all .3s ease-out;
                            }
                        }
                    }
                }
                li:hover .cardBox .i-toggle-yellow {
                    opacity: 1;
                }
                li:hover .cardBox h3:after {
                    width: 40px;
                    left:46%;
                }
            }
        }
    }
}
@media screen and (max-width:1000px) {
    .products{
        .main {
            width:100%;
            .cardList{
                width: 100%;
                .cardList_item{
                    display:block ;
                    li {
                        width:100%;
                        margin:15px 0 20px 0;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/Home/components/Products.vue